<script lang="ts" setup>
withDefaults(
  defineProps<{
    variant?: 'default' | 'full-purple' | 'color-only-border'
    disabled?: boolean
  }>(),
  {
    variant: 'default',
    disabled: false,
  },
)
</script>

<template>
  <button class="btn" :disabled="disabled" :class="[`variant-${variant}`]">
    <div class="flex flex-row items-center w-full" :class="{ 'justify-between gap-2': $slots.icon }">
      <slot name="icon" />

      <div
        class="w-full truncate tracking-wide font-semibold text-base leading-normal" :class="{
          'text-center': !$slots.icon,
          'text-left': $slots.icon || $slots.rightBlock,
        }"
      >
        <slot />
      </div>

      <div v-if="$slots.rightBlock" class="flex whitespace-pre text-base font-medium text-[#7540EE]">
        <slot name="rightBlock" />
      </div>
    </div>
  </button>
</template>

<style scoped>
@reference "tailwindcss";

.btn {
  @apply flex flex-row items-center justify-center h-12 text-white rounded-full tracking-wide leading-normal px-2 w-full cursor-pointer;
}

.btn.variant-full-purple {
  @apply text-white z-1 relative bg-gradient-to-r from-[#7540EE] to-[#AF55FF];
}

.btn.variant-full-purple::before {
  @apply absolute top-0 right-0 bottom-0 left-0 rounded-full -z-1 opacity-0 bg-gradient-to-br from-[#7540EE] to-[#AF55FF] transition-opacity ease-out;
  content: '';
}

.btn.variant-full-purple:hover::before {
  @apply opacity-100;
}

.btn.variant-full-purple:active::before {
  @apply opacity-60;
}

.btn.variant-default {
  @apply border-2 border-solid border-[#727277];
}

.theme-light .btn.variant-default {
  @apply bg-blue-50 text-black hover:bg-blue-100 active:bg-blue-200;
}

.btn.variant-color-only-border {
  @apply border-2 border-solid border-[#7540EE];
}

.btn.variant-default {
  @apply bg-white text-black hover:bg-[#E0E0E0] active:bg-[#EEEEEE];
}

.btn.variant-color-only-border {
  @apply text-black bg-white hover:bg-[#d5c3ff] active:bg-[#eee6ff];
}

.dark .btn.variant-default,
.onboarding-theme .btn.variant-default {
  @apply bg-[#151515] hover:bg-[#393939] active:bg-[#292929] text-white;
}

.dark .btn.variant-color-only-border,
.onboarding-theme .btn.variant-color-only-border {
  @apply bg-[#151515] hover:bg-[#2c1d4f] active:bg-[#231544] text-white;
}
</style>
